import { useState, useCallback } from 'react';
import { chatbotApi } from '../Services/chatbotApi';

export const useFeedback = (showToast) => {
    const [feedbackState, setFeedbackState] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    /**
     * Verifica si un mensaje ya fue calificado
     */
    const isMessageRated = useCallback((messageId) => {
        return feedbackState[messageId]?.hasRated || false;
    }, [feedbackState]);

    /**
     * Obtiene la calificación de un mensaje
     */
    const getMessageRating = useCallback((messageId) => {
        return feedbackState[messageId]?.rating || null;
    }, [feedbackState]);

    /**
     * Envía el feedback al backend
     */
    const submitFeedback = useCallback(async (messageId, rating, comment = null) => {
        if (!messageId || !rating) {
            showToast?.('Datos de feedback inválidos', 'error');
            return { success: false };
        }

        setIsSubmitting(true);

        try {
            const response = await chatbotApi.submitFeedback({
                messageId,
                rating,
                comment
            });

            if (response.success) {
                // Actualizar estado local
                setFeedbackState(prev => ({
                    ...prev,
                    [messageId]: {
                        hasRated: true,
                        rating: rating,
                        comment: comment,
                        submittedAt: Date.now()
                    }
                }));

                showToast?.('Thank you for your feedback!', 'success');
                return { success: true };
            }

            showToast?.('Error submitting feedback', 'error');
            return { success: false };

        } catch (error) {
            console.error('Error submitting feedback:', error);
            showToast?.(error.message || 'Connection error', 'error');
            return { success: false };
        } finally {
            setIsSubmitting(false);
        }
    }, [showToast]);

    /**
     * Marca un mensaje como calificado localmente (para cargar histórico)
     */
    const markAsRated = useCallback((messageId, rating) => {
        setFeedbackState(prev => ({
            ...prev,
            [messageId]: {
                hasRated: true,
                rating: rating,
                submittedAt: Date.now()
            }
        }));
    }, []);

    return {
        feedbackState,
        isSubmitting,
        isMessageRated,
        getMessageRating,
        submitFeedback,
        markAsRated
    };
};